<template>
  <b-modal
    :active.sync="showModal"
    trap-focus
    aria-role="dialog"
    aria-modal
    has-modal-card
    @close="closeModal"
  >
    <form action="">
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <p class="modal-card-title">Sign in required.</p>
        </header>
        <section class="modal-card-body">
          <p>You need to be logged in to add to your collection.</p>
        </section>
        <footer class="modal-card-foot">
          <button class="button" type="button" @click="closeModal">
            Cancel
          </button>
          <button class="button is-primary" @click.prevent="redirectToLogin()">
            Log in
          </button>
        </footer>
      </div>
    </form>
  </b-modal>
</template>

<script>
export default {
  name: 'AddToCartModal',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    redirectUrl: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      showModal: this.show
    }
  },
  watch: {
    show() {
      this.showModal = this.show
    }
  },
  methods: {
    redirectToLogin() {
      this.$emit('login-redirect')
      this.$router.push({
        name: 'Login',
        query: { redirect: this.redirectUrl }
      })
    },
    closeModal() {
      this.showModal = false
      this.$emit('close-modal')
    }
  }
}
</script>
